import React from 'react';
import clsx from 'clsx';
import type { ProgressBarProps } from './progressBar.types';
import {
  getStatusColor,
  getSizeConfig,
  normalizeProgress,
  normalizeBarWidth,
} from './progressBar.definitions';

export default function ProgressBar({
  progress,
  status,
  size = 'md',
  showPercentage = true,
  animated = true,
  className,
}: ProgressBarProps) {
  // Valor exibido pode ser > 100% quando meta é ultrapassada
  const displayProgress = normalizeProgress(progress);

  // Largura da barra limitada a 100% para não exceder o container
  const barWidth = normalizeBarWidth(progress);

  const sizeConfig = getSizeConfig(size);
  const statusColor = getStatusColor(status);

  return (
    <div className={clsx('w-full', className)}>
      <div className="flex items-center justify-between mb-1">
        {showPercentage && (
          <span
            className={clsx(
              'font-medium text-gray-700 font-montserrat',
              sizeConfig.fontSize
            )}
          >
            {Math.round(displayProgress)}%
          </span>
        )}
      </div>
      <div
        className={clsx(
          'w-full bg-gray-200 rounded-full overflow-hidden',
          sizeConfig.height
        )}
      >
        <div
          className={clsx(
            'h-full rounded-full',
            statusColor,
            animated && 'transition-all duration-300 ease-out'
          )}
          style={{ width: `${barWidth}%` }}
          role="progressbar"
          aria-valuenow={barWidth}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}
